import { SlidersHorizontal, Search, X } from "lucide-react";

import { Input } from "@/components/ui/input";

interface CaixasToolbarProps {
  draftSearch: string;
  onDraftSearchChange: (value: string) => void;
  onClearSearch: () => void;
  onOpenFilters: () => void;
  hasAppliedFilters: boolean;
  onClearFilters: () => void;
}

export function CaixasToolbar({
  draftSearch,
  onDraftSearchChange,
  onClearSearch,
  onOpenFilters,
  hasAppliedFilters,
  onClearFilters,
}: CaixasToolbarProps) {
  return (
    <div className="caixas-toolbar">
      <div className="caixas-search-wrap">
        <Search
          size={16}
          style={{
            position: "absolute",
            left: "0.85rem",
            color: "var(--login-muted)",
            pointerEvents: "none",
          }}
        />
        <Input
          aria-label="Pesquisar caixas"
          placeholder="Pesquisar clientes, lojas ou observações..."
          className="caixas-search-input"
          value={draftSearch}
          onInput={(event) => onDraftSearchChange(event.currentTarget.value)}
        />
        {draftSearch ? (
          <button
            type="button"
            aria-label="Limpar pesquisa"
            className="caixas-icon-button"
            onClick={onClearSearch}
            style={{
              position: "absolute",
              right: "0.25rem",
              width: "44px",
              height: "44px",
              border: "none",
              background: "transparent",
            }}
          >
            <X size={16} />
          </button>
        ) : null}
      </div>
      <div className="caixas-toolbar-actions">
        <button
          type="button"
          className="caixas-pill-button caixas-pill-button-secondary"
          aria-label="Filtros"
          onClick={onOpenFilters}
        >
          <SlidersHorizontal size={18} strokeWidth={1.8} aria-hidden="true" />
          <span>Filtros</span>
        </button>
      </div>
      {hasAppliedFilters ? (
        <div className="caixas-actions">
          <button
            type="button"
            className="caixas-pill-button caixas-pill-button-secondary"
            onClick={onClearFilters}
          >
            Limpar
          </button>
        </div>
      ) : null}
    </div>
  );
}
